/**
 * Throttle functions for better performance
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * https://vanillajstoolkit.com/helpers/debounce/
 * @param  {Function} fn The function to debounce
 */
var throttle = function (fn) {

	// Setup a timer
	var timeout;

	// Return a function to run debounced
	return function () {

		// Setup the arguments
		var context = this;
		var args = arguments;

		// If there's a timer, cancel it
		if (timeout) {
			window.cancelAnimationFrame(timeout);
		}

		// Setup the new requestAnimationFrame()
		timeout = window.requestAnimationFrame(function () {
			fn.apply(context, args);
		});

	}

};

/* USAGE:

// Throttle function needs to be stored as var
var resizeThrottle = throttle(function() {
    // Do your thing
});

on('resize', window, resizeThrottle);

*/
